"use client";

import { c as _c } from "react/compiler-runtime";
import { SidebarTrainingCard } from "@/components/training/sidebar-training-card";
import { SidebarFooter as ShadcnSidebarFooter } from "@/components/ui/sidebar";
import { useSidebar } from "@/components/ui/sidebar";
import ProfileButton from "./profile-button";
import { SetupOnboardingPanel } from "./setup-onboarding-panel";
export function SidebarFooter() {
  const $ = _c(1);
  const {
    state
  } = useSidebar();
  const isCollapsed = state === "collapsed";
  if (isCollapsed) {
    return null;
  }
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ShadcnSidebarFooter className="p-0"><SidebarTrainingCard /><SetupOnboardingPanel /><ProfileButton /></ShadcnSidebarFooter>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}